module.exports = __webpack_public_path__ + "img/chevron-down-solid-white.32c2a233.svg";